<template>
    <div>
        <h3>退会する</h3>
        <div>
            <p>
                退会メニューから、貸し本棚アカウントを停止することができます。
            </p>
            <p>
                停止されたアカウントは、一定期間経過後に自動削除されます。
                ログイン情報だけでなく、投稿した小説、画像、感想などすべての情報が抹消されます。
            </p>
            <p>
                もし間違えて退会した場合、運営までご連絡ください。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "退会 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>